export default {
  draftBox: 'Draft Box',
  countrySite: 'Country Site',
  category: 'Category',
  draftId: 'Draft ID',
  latestModifiedDate: 'Latest Modified Date',
  productName: 'Product Name',
  pleaseSelect: 'Please select',
  selectDate: 'select date',
  reset: 'Reset',
  search: 'Search',
  operation: 'Operation',
  edit: 'Edit',
  remove: 'Remove',
  basicSite: 'Basic Site',
  saveDraft: 'Save Draft'
}
